<template>
  <div class="biglietti" v-loading="loading">
    <div class="action" v-if="actionBar">
      <el-button class="WEB-button WEB-button-alternative" v-if="enableAction('add')" @click="add">{{
        $t('btn.add').toUpperCase() }}</el-button>
    </div>
    <div style="marginTop:25px" v-else></div>
    <el-table :data="biglietti" @row-click="open" :empty-text="$t('biglietti.msg.noData')" class="custom-table">
      <el-table-column header-align="center" align="center" width="50">

        <template slot-scope="scope" slot="header">
          <div class="icon-title">
            <el-popover placement="top" v-model="visibleInfo" :key="scope.toString()">
              <div>
                <div>
                  <icon name="riv-circle" class="status-saved" scale="0.8"></icon>
                  <span>{{ $t('statusDett.0') }}</span>
                </div>
                <div>
                  <icon name="riv-circle" class="status-send" scale="0.8"></icon>
                  <span>{{ $t('statusDett.1') }}</span>
                </div>
                <div>
                  <icon name="riv-circle" class="status-rejected" scale="0.8"></icon>
                  <span>{{ $t('statusDett.2') }}</span>
                </div>
                <div>
                  <icon name="riv-circle" class="status-approved" scale="0.8"></icon>
                  <span>{{ $t('statusDett.3') }}</span>
                </div>
              </div>

              <span slot="reference">
                <icon class="pointer" name="riv-help" scale="1"></icon>
              </span>
            </el-popover>

          </div>
        </template>

        <template slot-scope="scope">
          <div class="data-wrapper">
            <el-tooltip class="item" effect="dark" :content="$t('statusDett.' + scope.row.statoAvanz)"
              placement="top-start">
              <icon :name="getStatoIcon_dett(scope.row.statoAvanz)" :class="getStatoClass_dett(scope.row.statoAvanz)"
                scale="0.8"></icon>
            </el-tooltip>
          </div>
        </template>

      </el-table-column>
      <el-table-column header-align="center" align="center" :label="$t('biglietti.label.giorno')" width="100">

        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ scope.row.giorno | formattaData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" :label="$t('biglietti.label.orario')" width="100">

        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ scope.row.oraPart | formattaHours }} / {{ scope.row.oraArr | formattaHours }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="partenza" :label="$t('biglietti.label.partenza')" min-width="200">
      </el-table-column>

      <el-table-column prop="destinazione" :label="$t('biglietti.label.destinazione')" min-width="200">
      </el-table-column>

      <el-table-column width="50" header-align="center" align="center">

        <template slot-scope="scope" slot="header">
          <el-tooltip class="item" effect="dark" :content="$t('biglietti.label.navetta')" placement="top-start"
            :key="scope.toString()">
            <icon name="riv-trasferte2" scale="1.2"></icon>
          </el-tooltip>
        </template>

        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ desNanetta(scope.row) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column v-if="enableAction('del')" width="50" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="actions">
            <icon name="riv-delete2" scale="1.2" @click.native.stop="del(scope.row)"></icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" class="custom-pagination" background
      layout="prev, pager, next" :total="nrItems" :page-size="pag_for" @current-change="changePage">
    </el-pagination>

    <!-- Dialog di creazione di una nuova richiesta di ferie -->
    <el-dialog :title="($t('biglietti.label.title').toUpperCase())" :visible.sync="showModal" class="custom-dialog"
      :append-to-body="true" custom-class="offset-5 col-14">

      <el-form class="" :disabled="trasferta.terminata === 'T' || !actionBar">
        <div class="elemento row row-custom"
          :class="[!this.validaBiglietto && (this.form.giorno === undefined || this.form.giorno === null) ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('biglietti.label.giorno') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="form.giorno">
              <el-option v-for="item in picker_days" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaBiglietto && (this.form.mezzo === undefined || this.form.mezzo === '') ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('biglietti.label.mezzoTrasp') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <div class="my-value col-24 no-padding">
              <el-select v-model="form.mezzo">
                <el-option v-for="item in tbl_mezzi" :key="item.id" :label="item.desc" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaBiglietto && (this.form.partenza === undefined || this.form.partenza === '') ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('biglietti.label.partenza') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <div class="my-value col-24 no-padding">
              <el-input placeholder="" v-model="form.partenza">
              </el-input>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaBiglietto && (this.form.oraPart === undefined || this.form.oraPart === null) ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('biglietti.label.orarioPart') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-time-picker v-model="form.oraPart" format="HH:mm" value-format="HH:mm">
            </el-time-picker>
            <!--<el-time-select class="dt-picker time"
                            v-model="form.oraPart"
                            placeholder="Select time"
                            :picker-options="{start: '00:00',step: '00:15',end: '24:00', format:'HH:mm'}">
            </el-time-select>-->
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaBiglietto && (this.form.destinazione === undefined || this.form.destinazione === '') ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('biglietti.label.destinazione') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="form.destinazione">
            </el-input>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaBiglietto && (this.form.oraArr === undefined || this.form.oraArr === null) ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('biglietti.label.orarioArrivo') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-time-picker v-model="form.oraArr" format="HH:mm" value-format="HH:mm">
            </el-time-picker>
            <!--<el-time-select class="dt-picker time"
                            v-model="form.oraArr"
                            placeholder="Select time"
                            :picker-options="{start: '00:00',step: '00:15',end: '24:00', format:'HH:mm'}">
            </el-time-select>-->
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('biglietti.label.note') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="" v-model="form.notaDip">
            </el-input>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-area col-24 no-padding">
            {{ $t('biglietti.label.navetta') }}
          </div>
          <div class="col-12 no-padding-left">
            <div class="elemento row row-custom">
              <div class="my-label trasp col-24 no-padding">
                {{ $t('biglietti.label.navettaDa', { partenza: form.partenza }) }}
                <el-checkbox v-model="form.checkedNavettaFrom" class="riva-header-checkbox"
                  style="float: left; margin-right: 10px;"></el-checkbox>
              </div>
              <div class="my-value trasp col-24 no-padding">
                <el-input placeholder="" v-model="form.navettaPart" :disabled="!form.checkedNavettaFrom">
                </el-input>
              </div>

              <div class="my-value trasp col-24 no-padding">
                <el-time-picker v-model="form.navettaOraPart" format="HH:mm" :placeholder="$t('biglietti.label.orario')"
                  value-format="HH:mm" :disabled="!form.checkedNavettaFrom">
                </el-time-picker>
                <!--<el-time-select class="dt-picker time"
                                v-model="form.navettaOraPart"
                                :placeholder="$t('biglietti.label.orario')"
                                :picker-options="{start: '00:00',step: '00:15',end: '24:00', format:'HH:mm'}">
                </el-time-select>-->
              </div>
            </div>
          </div>
          <div class="col-12 no-padding-right">
            <div class="elemento row row-custom">
              <div class="my-label trasp col-24 no-padding">
                {{ $t('biglietti.label.navettaPer', { destinazione: form.destinazione }) }}
                <el-checkbox v-model="form.checkedNavettaTo" class="riva-header-checkbox"
                  style="float: left; margin-right: 10px;"></el-checkbox>
              </div>
              <div class="my-value trasp col-24 no-padding">
                <el-input placeholder="" v-model="form.navettaDest" :disabled="!form.checkedNavettaTo">
                </el-input>
              </div>
            </div>
          </div>

        </div>

        <div v-if="form.statoAvanz !== '0'">
          <div class="elemento row row-custom">
            <div class="my-area col-24 no-padding">
              {{ $t('biglietti.label.segreteria') }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.notaSeg !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('biglietti.label.noteSegreteria') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.notaSeg }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div v-if="form.nomeFile !== ''" class="col-24 no-padding">
              <div @click="getDoc(form.nomeFile)">
                <icon name="riv-download" scale="1.5"></icon>
                <span class="truncate applicazione">{{ form.nomeFile }}</span>
              </div>
            </div>
          </div>
        </div>


      </el-form>

      <span slot="footer" class="" v-if="actionBar">
        <el-button class="WEB-button WEB-button-alternative" v-if="trasferta.terminata === 'T'" @click="close">{{
          $t('btn.close') }}</el-button>
        <el-button class="WEB-button WEB-button-alternative" v-if="trasferta.terminata !== 'T'" @click="close">{{
          $t('btn.annulla') }}</el-button>
        <el-button class="WEB-button WEB-button-primary" v-if="trasferta.terminata !== 'T'" @click="checkSave">{{
          $t('btn.salva').toUpperCase() }}</el-button>
      </span>
      <span slot="footer" class="" v-else>
        <el-button class="WEB-button WEB-button-alternative" @click="close">{{ $t('btn.close') }}</el-button>
      </span>

    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Biglietti',
  props: ['trasferta', 'actionBar'],
  i18n: {
    messages: {
      it_IT: {
        biglietti: {
          label: {
            title: 'Biglietto',
            status: 'Stato',
            giorno: 'Giorno',
            mezzoTrasp: 'Mezzo di Trasporto',
            partenza: 'Partenza',
            destinazione: 'Destinazione',
            orarioPart: 'Ora di Partenza',
            orarioArrivo: 'Ora di Arrivo',
            orario: 'Orario',
            note: 'Nota',
            navetta: 'Trasporti',
            navettaDa: 'Si richiede il Trasporto per {partenza} da?',
            navettaPer: 'Si richiede il Trasporto da {destinazione} per?',
            segreteria: 'Segreteria',
            noteSegreteria: 'Note Segreteria',
            allegati: 'Allegati'
          },
          msg: {
            saveTransportFrom: 'Salvataggio Trasporto Andata',
            saveTransportTo: 'Salvataggio Trasporto Ritorno',
            noData: 'Nessun Biglietto Trovato',
            datiObbligatoriMancanti: 'Dati obbligatori mancanti'
          }
        }
      },
      fr_FR: {
        biglietti: {
          label: {
            title: 'Réserver Billets Voyage',
            status: 'Etat',
            giorno: 'Jour',
            mezzoTrasp: 'Véhicule',
            partenza: 'Départ',
            destinazione: 'Destination',
            orarioPart: 'heure de départ',
            orarioArrivo: 'heure de arrivé',
            orario: 'Horaire',
            note: 'Notes',
            navetta: 'Transport',
            navettaDa: 'Avez-vous besoin de transport pour {partenza} à partir de?',
            navettaPer: 'Avez-vous besoin d\'un moyen de transport de {destinazione} pour?',
            segreteria: 'Secrétaire',
            noteSegreteria: 'Annotations de la Secrétaire',
            allegati: 'Annexes'
          },
          msg: {
            saveTransportFrom: 'Sauvetage Transport Aller',
            saveTransportTo: 'Sauvetage Transport Retour',
            noData: 'Aucun Billet trouvé',
            datiObbligatoriMancanti: 'Données obligatoires manquantes'
          }
        }
      },
      es_ES: {
        biglietti: {
          label: {
            title: 'Ticket',
            status: 'Estado',
            giorno: 'Día',
            mezzoTrasp: 'Transporte',
            partenza: 'Salida',
            destinazione: 'Destino',
            orarioPart: 'Hora de salida',
            orarioArrivo: 'Hora de llegada',
            orario: 'Horas',
            note: 'Nota',
            navetta: 'Transporte',
            navettaDa: 'Necesario transporte hasta {partenza} desde',
            navettaPer: 'Necesario transporte desde {destinazione} hasta',
            segreteria: 'Secretaria',
            noteSegreteria: 'Nota de la Secretaria',
            allegati: 'Adjuntos'
          },
          msg: {
            saveTransportFrom: 'Viaje de ida guardado',
            saveTransportTo: 'Viaje de vuelta guardado',
            noData: 'Sin informacion',
            datiObbligatoriMancanti: 'Faltan datos obligatorios'
          }
        }
      },
      de_DE: {
        biglietti: {
          label: {
            title: 'Ticket',
            status: 'Land',
            giorno: 'Tag',
            mezzoTrasp: 'Transport',
            partenza: 'Abreiseort',
            destinazione: 'Reiseziel',
            orarioPart: 'Abfahrtszeit',
            orarioArrivo: 'Ankunftszeit',
            orario: 'Zeitraum',
            note: 'Notiz',
            navetta: 'Transport',
            navettaDa: 'Transport bis {partenza} ab?',
            navettaPer: 'Transport ab {destinazione} bis?',
            segreteria: 'Sekretariat',
            noteSegreteria: 'Notiz des Sekretariat',
            allegati: 'Anlage'
          },
          msg: {
            saveTransportFrom: 'Transport nach außen retten',
            saveTransportTo: 'Rücktransport retten',
            noData: 'Keine Tickets gefunden',
            datiObbligatoriMancanti: 'Fehlende Pflichtangaben'
          }
        }
      },
      en_GB: {
        biglietti: {
          label: {
            title: 'Ticket',
            status: 'Status',
            giorno: 'Day',
            mezzoTrasp: 'Means of Transport',
            partenza: 'Departure',
            destinazione: 'Destination',
            orarioPart: 'Departure Time',
            orarioArrivo: 'Arrival Time',
            orario: 'Time',
            note: 'Note',
            navetta: 'Transport Services',
            navettaDa: 'Request transport from {partenza}?',
            navettaPer: 'Request transport to {destinazione}?',
            segreteria: 'Secretary',
            noteSegreteria: 'Secretary Notes',
            allegati: 'Attachments'
          },
          msg: {
            saveTransportFrom: 'Saving Outbound Transport',
            saveTransportTo: 'Saving Return Transport',
            noData: 'No Tickets Found',
            datiObbligatoriMancanti: 'Required data is missing'
          }
        }
      }
    }
  },
  data() {
    return {
      loading: false,
      biglietti: [],
      currentPage: 1,
      pag_for: 8,
      pag_order: 'DD',
      nrPages: 0,
      nrItems: 0,
      showModal: false,
      form: {},
      tbl_mezzi: [],
      visibleInfo: false,
      validaBiglietto: true,
      validaNavettaFrom: true,
      validaNavettaTo: true,
      picker_days: [],
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    },
    formattaHours: function (hours) {
      if (hours !== '') {
        return hours.replace(',', ':')
      } else {
        return ' '
      }
    }
  },
  beforeMount: function () {
    this.loading = true
    this.loadMezzi()
    this.loadBiglietti()

    moment.locale(this.$i18n.locale)

    const dataDal = moment(this.trasferta.dataDal, 'YYYYMMDD')
    const dataAl = moment(this.trasferta.dataAl, 'YYYYMMDD')
    const numDays = dataAl.diff(dataDal, 'days') + 1

    this.picker_days = Array.from({ length: numDays }, (_, i) => {
      const giorno = dataDal.clone().add(i, 'days')
      return {
        value: giorno.format('YYYYMMDD'),
        label: giorno.format('dddd Do MMM YYYY')
      }
    })
  },
  mounted: function () {
  },
  methods: {
    loadBiglietti: function () {
      this.loading = true
      this.$set(this, 'biglietti', [])
      this.$http.get('trasferte/' + this.$store.state.country + '/biglietti', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.pag_order,
          vista: this.actionBar ? '' : 'R'
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.biglietti = response.body.data
            if (this.currentPage === 1) {
              this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
            }
          } else {
            if (response.body.msg[0].msgId !== '1218') {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'biglietti', [])
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.loading = false
        })
    },
    add: function () {
      this.validaBiglietto = true
      this.validaNavettaFrom = true
      this.validaNavettaTo = true
      this.$set(this, 'form', {})
      this.$set(this.form, 'giorno', this.trasferta.dataDal)
      this.$set(this.form, 'checkedNavettaTo', false)
      this.$set(this.form, 'checkedNavettaFrom', false)
      this.form.id = ''
      this.form.idTraspAnd = ''
      this.form.idTraspRit = ''
      this.form.idTrasferta = this.trasferta.idTrasferta
      this.form.statoAvanz = '0'
      this.showModal = true
    },
    open: function (row, event, column) {
      this.validaBiglietto = true
      this.validaNavettaFrom = true
      this.validaNavettaTo = true
      this.$set(this, 'form', {})
      this.form.idTrasferta = row.idTrasferta
      this.form.id = row.id
      this.form.statoAvanz = row.statoAvanz
      this.$set(this.form, 'giorno', row.giorno)
      this.$set(this.form, 'oraPart', moment(row.oraPart, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'oraArr', moment(row.oraArr, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'mezzo', row.mezzo)
      this.$set(this.form, 'partenza', row.partenza)
      this.$set(this.form, 'destinazione', row.destinazione)
      this.$set(this.form, 'notaDip', row.notaDip.split("\\n").join("\n"))
      if (row.idTraspAnd != undefined) {
        this.form.idTraspAnd = row.idTraspAnd
        this.$set(this.form, 'navettaPart', row.luogoPartTraspAnd)
        this.$set(this.form, 'navettaOraPart', moment(row.oraPartTraspAnd, 'HH,mm').format('HH:mm'))
        this.$set(this.form, 'checkedNavettaFrom', true)
      } else {
        this.form.idTraspAnd = ''
        this.$set(this.form, 'checkedNavettaFrom', false)
      }
      if (row.idTraspRit != undefined) {
        this.form.idTraspRit = row.idTraspRit
        this.$set(this.form, 'navettaDest', row.luogoArrTraspRit)
        this.$set(this.form, 'checkedNavettaTo', true)
      } else {
        this.form.idTraspRit = ''
        this.$set(this.form, 'checkedNavettaTo', false)
      }

      // Segreteria
      this.form.notaSeg = row.notaSeg
      this.form.nomeFile = row.nomeFile

      // Show Modal
      this.showModal = true
    },
    close: function () {
      this.showModal = false
    },
    checkSave: function () {
      this.validaBiglietto = true
      this.validaNavettaFrom = true
      this.validaNavettaTo = true
      if (this.form.giorno === null || this.form.giorno === undefined) {
        this.validaBiglietto = false
      }
      if (this.form.mezzo === '' || this.form.mezzo === undefined) {
        this.validaBiglietto = false
      }
      if (this.form.partenza === '' || this.form.partenza === undefined) {
        this.validaBiglietto = false
      }
      if (this.form.oraPart === null || this.form.oraPart === undefined) {
        this.validaBiglietto = false
      }
      if (this.form.destinazione === '' || this.form.destinazione === undefined) {
        this.validaBiglietto = false
      }
      if (this.form.oraArr === null || this.form.oraArr === undefined) {
        this.validaBiglietto = false
      }

      // Verifico Dati Navette
      if (this.form.checkedNavettaFrom) {
        if (this.form.navettaPart === '' || this.form.navettaPart === undefined) {
          this.validaNavettaFrom = false
        }
        if (this.form.navettaOraPart === '' || this.form.navettaOraPart === undefined) {
          this.validaNavettaFrom = false
        }
      }
      if (this.form.checkedNavettaTo) {
        if (this.form.navettaDest === '' || this.form.navettaDest === undefined) {
          this.validaNavettaTo = false
        }
      }
      if (this.validaBiglietto && this.validaNavettaFrom && this.validaNavettaTo) {
        this.save()
      } else {
        this.$message.error(this.$i18n.t('biglietti.msg.datiObbligatoriMancanti'))
      }
    },
    save: function () {
      let _this = this
      this.loading = true
      let objTraspAnd = {
        'idTrasferta': this.form.idTrasferta,
        'id': this.form.idTraspAnd === '' ? '' : this.form.idTraspAnd,
        'giorno': this.form.giorno,
        'oraPart': moment(this.form.navettaOraPart, 'HH:mm').format('HH.mm.ss'),
        'partenza': this.form.navettaPart,
        'destinazione': this.form.partenza,
        'idBiglietto': this.form.id,
        'navetta': 'A'
      }

      let navettaAnd = false
      if (this.form.idTraspAnd === '' && this.form.checkedNavettaFrom) {
        objTraspAnd['operazione'] = '*ADD'
        objTraspAnd['statoAvanz'] = '0'
        navettaAnd = true
      } else if (this.form.id != '' && this.form.idTraspAnd != '' && !this.form.checkedNavettaFrom) {
        objTraspAnd['operazione'] = '*DEL'
        navettaAnd = true
      } else if (this.form.id != '' && this.form.idTraspAnd != '' && this.form.checkedNavettaFrom) {
        objTraspAnd['operazione'] = '*UPD'
        navettaAnd = true
      }

      let objTraspRit = {
        'idTrasferta': this.form.idTrasferta,
        'id': this.form.idTraspRit === '' ? '' : this.form.idTraspRit,
        'giorno': this.form.giorno,
        'oraPart': moment(this.form.oraArr, 'HH:mm').format('HH.mm.ss'),
        'partenza': this.form.destinazione,
        'destinazione': this.form.navettaDest,
        'idBiglietto': this.form.id,
        'navetta': 'R'
      }

      let navettaRit = false
      if (this.form.idTraspRit === '' && this.form.checkedNavettaTo) {
        objTraspRit['operazione'] = '*ADD'
        objTraspRit['statoAvanz'] = '0'
        navettaRit = true
      } else if (this.form.id != '' && this.form.idTraspRit != '' && !this.form.checkedNavettaTo) {
        objTraspRit['operazione'] = '*DEL'
        navettaRit = true
      } else if (this.form.id != '' && this.form.idTraspRit != '' && this.form.checkedNavettaTo) {
        objTraspRit['operazione'] = '*UPD'
        navettaRit = true
      }

      let obj = {
        'idTrasferta': this.form.idTrasferta,
        'id': this.form.id === '' ? '' : this.form.id,
        'statoAvanz': this.form.statoAvanz,
        'operazione': this.form.id === '' ? '*ADD' : '*UPD',
        'giorno': this.form.giorno,
        'oraPart': moment(this.form.oraPart, 'HH:mm').format('HH.mm.ss'),
        'oraArr': moment(this.form.oraArr, 'HH:mm').format('HH.mm.ss'),
        'partenza': this.form.partenza,
        'destinazione': this.form.destinazione,
        'mezzo': this.form.mezzo,
        'notaDip': this.form.notaDip,
        'navettaAndata': objTraspAnd,
        'navettaRitorno': objTraspRit
      }

      if (!navettaAnd) {
        delete obj['navettaAndata']
      }
      if (!navettaRit) {
        delete obj['navettaRitorno']
      }

      this.$http.post('trasferte/' + this.$store.state.country + '/biglietto', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.respBiglietto.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })

            if (response.body.respNavettaAndata != undefined) {
              setTimeout(function () {
                // Notifico l'azione di salvataggio Alloggio
                //Notifico il salvataggio del giorno
                _this.$notify({
                  title: _this.$i18n.t('biglietti.msg.saveTransportFrom'),
                  message: response.body.respNavettaAndata.msg[0].msgTxt,
                  type: response.body.respNavettaAndata.rc === 0 ? 'success' : 'error',
                  duration: process.env.duration
                })
              }, 400)
            }

            if (response.body.respNavettaRitorno != undefined) {
              setTimeout(function () {
                // Notifico l'azione di salvataggio Alloggio
                //Notifico il salvataggio del giorno
                _this.$notify({
                  title: _this.$i18n.t('biglietti.msg.saveTransportTo'),
                  message: response.body.respNavettaRitorno.msg[0].msgTxt,
                  type: response.body.respNavettaRitorno.rc === 0 ? 'success' : 'error',
                  duration: process.env.duration
                })
              }, 800)
            }
            this.loadBiglietti()
            this.showModal = false
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    del: function (row) {
      this.loading = true
      this.$http.delete('trasferte/' + this.$store.state.country + '/biglietto/' + row.idTrasferta + '/' + row.id)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadBiglietti()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    changePage: function (page) {
      this.currentPage = page
      this.loadBiglietti()
    },
    loadMezzi: function (value) {
      this.$http.get('trasferte/' + this.$store.state.country + '/filtri', {
        params: {
          id: 'mezziBiglietto'
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.tbl_mezzi = response.body.data
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    },
    getDoc: function (nomeFile) {
      //let url = ('download/trasferta?fileName=' + nomeFile + '&country=' + this.$store.state.country + '&token=' + sessionStorage.getItem('token'))
      let url = ('download/document?codLang=' + sessionStorage.getItem('codLang') + '&delete=NO' +
        '&fileName=' + nomeFile + '&filePath=PaiCEDEXP' + '&token=' + sessionStorage.getItem('token'))
      let win = window.open(process.env.baseUrlSpring + url, '_blank')
      win.focus()
    },
    isDisabled: function () {
      if (this.trasferta.terminata === 'T' || this.form.id != '') {
        return true
      } else {
        return false
      }
    },
    desNanetta: function (row) {
      if (row.idTraspAnd !== undefined && row.idTraspAnd !== '' && row.idTraspRit !== undefined && row.idTraspRit !== '') {
        return 'A/R'
      } else if (row.idTraspAnd !== undefined && row.idTraspAnd != '') {
        return 'A'
      } else if (row.idTraspRit !== undefined && row.idTraspRit != '') {
        return 'R'
      } else {
        return ''
      }
    },
    enableAction: function (action, row) {
      let statoTrasferta = this.trasferta.statoAvanz
      if (this.trasferta.terminata === 'T') {
        return false
      }
      switch (action) {
        case 'del':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '5') {
            return true
          } else {
            return false
          }
        case 'add':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '6') {
            return true
          } else {
            return false
          }
      }
      return false
    },
    getStatoIcon_dett: function (stato) {
      switch (stato) {
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
          return 'riv-circle'
        default:
          return ''
      }
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          return 'status-send'
        default:
          return ''
      }
    },
    /*changeInput: function (tipo) {
      if (tipo === 'navettaPart' &&  this.form.checkedNavettaFrom && this.form.navettaPart >= 1 && !state.check.navettaPart) {
        state.check.otp = true
      } else if (tipo === 'navettaDest' &&  this.form.checkedNavettaFrom && this.form.navettaDest >= 1 && !state.check.navettaDest) {
        state.check.pin = true
      }
    }*/
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.biglietti {
  .action {
    height: 53px;
    text-align: right;
    padding-top: 10px;
  }

  height: 100%;
  //min-width: 1250px;
  max-width: 100%;

  .el-checkbox {
    margin-bottom: 0px;
    margin-top: 10px;

    .el-checkbox__inner {
      border-radius: 0px;
    }

    &.is-checked {
      .el-checkbox__inner {
        background-color: @greenRiva;
        border-color: @greenRiva;
      }
    }
  }
}

.row {
  &.row-error {
    .my-label {
      color: red !important;
    }

    .my-input {
      border: 1px solid red !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Trasferte/Biglietti.vue